import { useEffect, useState } from 'react'
import { LVType } from '../../../utils/schema/CommonSchema'
import { Box } from '@mui/material'

type Props = {
  currentTab: LVType
  onClick: any
  list: LVType[]
}

const Tabs = (props: Props) => {
  const { currentTab, onClick, list } = props
  const [borderStyle, setBorderStyle] = useState<{ left: number; width: number }>({ left: 0, width: 0 })

  // Calculate the left position and width of the border based on the selected tab
  const calculateBorderStyle = () => {
    const currentIndex = list.findIndex((item) => item.value === currentTab.value)
    const tabElement = document.getElementById(`tab_${currentIndex}`)
    if (tabElement) {
      setBorderStyle({ left: tabElement.offsetLeft, width: tabElement.offsetWidth })
    }
  }

  // Call calculateBorderStyle when the component mounts or when the currentTab changes
  useEffect(() => {
    calculateBorderStyle()
  }, [currentTab])

  return (
    <div className="relative">
      <Box borderColor={'secondary.dark'} bgcolor={'secondary.main'} className="flex gap-x-16 border-y pl-8 py-1 border-t-0 overflow-x-auto max-w-[100vw]">
        {list.map((items, index) => {
          return (
            <Box
              id={`tab_${index}`}
              sx={{
                color: currentTab.value === items.value ? 'primary.dark' : 'primary.main',
                '&:hover': {
                  color: 'primary.dark', // Adjust to a darker shade or reduce opacity
                },
              }}
              className={`${items?.label?.toLowerCase()?.includes('nai') ? '' : 'uppercase'} cursor-pointer py-2 text-sm font-semibold  ${currentTab.value === items.value ? 'text-secondary ' : 'text-black hover:text-secondary'}`}
              onClick={() => onClick(items)}
              key={items.value}
            >
              {items.label}
            </Box>
          )
        })}
        <Box
          bgcolor="primary.dark"
          className="absolute bottom-0 h-0.5 transition-all duration-300"
          style={{
            left: borderStyle.left - 32,
            width: borderStyle.width + 64,
          }}
        ></Box>
      </Box>
    </div>
  )
}

export default Tabs
